
import React from 'react';
import { FaThumbsUp } from 'react-icons/fa'; 
import MobileModel from '../Modals/MobileModel';
import {EditProfileLoader} from '../loader/loader';
import { BottomSheet } from 'react-spring-bottom-sheet';
import useDeviceType from '../../utils/useDeviceType';
const WaitingScreen = ({ nextScreen,loader,setLoader,formSubmit,setFormSubmit }) => {
    const modleBody = (
        <>
          <div className="flex flex-col items-center gap-4">
            <div className="w-40 h-40 rounded-full bg-blue-50 flex justify-center items-center">
              <FaThumbsUp className="text-6xl text-accent" />
            </div>
            <div>
              <h1 className="text-3xl font-medium text-coalBlack text-center mb-4">
                Thanks
              </h1>
              <p className="text-gray-400 max-w-xs mx-auto text-sm font-normal text-center">
              Hospital details have been updated successfully
              </p>
            </div>
          </div>
        </>
      );
      const modelFooter = (
        <>
          <div className="mt-4 mb-4 z-50">
            <button
              className="btn btn_primary_black text-white w-full rounded-xl"
              type="button"
              onClick={() => nextScreen()}
            >
              {!loader ? (
                'Done'
              ) : (
                <div className="text-xs">
                  <EditProfileLoader />
                </div>
              )}
            </button>
          </div>
        </>
      );
        const deviceType = useDeviceType();
      return (
      <>
            {(deviceType === 'Mobile' || deviceType === 'Tablet') ? (
              <div className="lg:hidden block">
                <BottomSheet
                  open={formSubmit}
                  onDismiss={() => setFormSubmit(false)} // Close on overlay click or swipe down
                  skipInitialTransition // Prevent bounce on first render
                  scrollLocking={false} // Prevent bounce on scroll
                >
                  <div className="p-2">
                    {modleBody}
                    {modelFooter}
                  </div>
                </BottomSheet>
              </div>
            ) : (
              <div className="absolute top-0 left-0 h-full w-full bg-white hidden md:flex">
                <div className="flex flex-col m-auto">
                  {modleBody}
                  {modelFooter}
                </div>
              </div>
            )}
          </>
      );
  
      
    };
    
    export default WaitingScreen;
